export default function ReviewStar({ scale = 24, percentage = 100 }: { scale?: number; percentage?: number }) {
  const id = Math.random().toString(36).slice(-8)

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={scale} height={scale} viewBox="0 0 20 20">
      <defs>
        <linearGradient id={id} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset={`${percentage}%`} stopColor="#00000" />
          <stop offset={`${percentage}%`} stopColor="#ededec" />
        </linearGradient>
      </defs>
      <path
        d="M11,3l2.472,5.008L19,8.816l-4,3.9.944,5.5L11,15.616l-4.944,2.6L7,12.712l-4-3.9,5.528-.808Z"
        transform="translate(-1 -0.5)"
        fill={`url(#${id})`}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  )
}
